import React, {createRef, RefObject} from 'react';
import Popover from "../../../gd-components/gd-popover/popover";
import PopoverPosition from '../../../gd-components/gd-popover/popover-position';
import PopoverHelpHint from "../../../gd-components/popover-menu/popover-help-hint/popover-help-hint";
import Task from "../../../model2/task/task";
import TaskWorkflow, {WorkflowType} from "../../../model2/status/task-workflow";
import TaskStatusMenu from "./render/menu";


type Props = {

    getTarget           : any

    task                : Task,
    workflow            : TaskWorkflow,

    hint?               : boolean,   // if true - show hint messages

    onStatusSelect      : onChangeCallback,

    hidePopover         : onChangeCallbackOptionalValue,
    togglePopover       : callback,

    // POPOVER ATTACHMENT
    popoverPosition     : PopoverPosition
}

export default class TaskStatusSelectorPopover extends React.Component<Props, any> {

    private refHintMessage  : RefObject<PopoverHelpHint>

    constructor(props:Props) {
        super(props);

        this.refHintMessage   = createRef()
    }

    onStatusClick = (statusId:ID) => {
        this.props.onStatusSelect(statusId)
    }

    onEditStatusesClick = () => {
        this.props.togglePopover()

        if (this.props.workflow.type===WorkflowType.TASK_FROM_PROJECT) {
            gd.goTo('p/'+this.props.task.projectId+'/info/settings/workflow');
        } else {
            gd.goTo('settings/task-types/'+this.props.task.taskTypeId);
        }
    }

    handleHoverOn = (info:string|null) => {
        if (!this.props.hint) return

        this.refHintMessage?.current?.setMessage(info)
    }

    handleHoverOff = () => {
        if (!this.props.hint) return
        this.refHintMessage?.current?.setMessage(null)
    }

    render() {

        this.props.workflow.applyACL(this.props.task)

        const statusesGrouped = this.props.workflow.getStatusesForSelector()

        return (
            <Popover popoverClass       =   "gd-select-status-popover"
                     attachment         =   {this.props.popoverPosition.attachment}
                     targetAttachment   =   {this.props.popoverPosition.targetAttachment}
                     targetOffset       =   {this.props.popoverPosition.targetOffset}
                     attachmentType     =   {this.props.popoverPosition.attachmentType}
                     constraints        =   {this.props.popoverPosition.constrains}

                     onClickOutside     =   {()=>{this.props.hidePopover()}}
                     getTargetFunc      =   {this.props.getTarget}
                     heightRestriction  =   "half-window-height">

                <TaskStatusMenu statusesGrouped     =   {statusesGrouped}
                                onStatusClick       =   {this.onStatusClick}
                                onEditStatusesClick =   {this.onEditStatusesClick}
                                handleHoverOn       =   {this.handleHoverOn}
                                handleHoverOff      =   {this.handleHoverOff}
                                hint                =   {this.props.hint}/>

            </Popover>
        );
    }
}
